module.exports = __webpack_public_path__ + "img/sidebar-background-4.1ab2f4b7.svg";